/**
 * ヘッダー アクティブメニュー
 */
const setActiveMenu = () => {
  const path = window.location.pathname.split('/')[1];
  document.querySelectorAll('.p-header__nav li > a').forEach((link) => {
    if (link.getAttribute('href').split('/')[1] === path) {
      link.parentElement.classList.add('is-active');
    }
  });
};
window.addEventListener('load', setActiveMenu);
window.addEventListener('resize', setActiveMenu);

/**
 * ヘッダー スクロールで縮小
 */
const handleScroll = () => {
  const scrollPos = window.scrollY;
  const header = document.querySelector('.l-header');
  const pHeader = document.querySelector('.p-header');
  if (scrollPos > 150) {
    header?.classList.add('is-scroll');
    pHeader?.classList.add('is-scroll');
  } else {
    header?.classList.remove('is-scroll');
    pHeader?.classList.remove('is-scroll');
  }
};
window.addEventListener('load', handleScroll);
window.addEventListener('scroll', handleScroll);

/**
 * モバイル用メニュー表示
 */
document.querySelector('.p-header__button')?.addEventListener('click', function () {
  const modal = document.querySelector('.modal');
  if (this.classList.contains('active')) {
    document.body.style.overflow = '';
    document.body.classList.remove('is-slidedown');
    if (modal) modal.style.display = 'none';
    this.classList.remove('active');
  } else {
    document.body.style.overflow = 'hidden';
    document.body.classList.add('is-slidedown');
    if (modal) modal.style.display = 'block';
    this.classList.add('active');
  }
});

/**
 * ページ上部に戻る
 */
const pagetop = document.querySelector('.p-footer__pagetop');
if (pagetop) {
  window.addEventListener('scroll', () => {
    pagetop.classList.toggle('is-visible', window.scrollY > 200);
  });
  pagetop.addEventListener('click', () => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  });
}

/**
 * Fancybox ギャラリー初期化
 */
if (typeof Fancybox !== 'undefined') {
  Fancybox.bind('[data-fancybox="gallery"]');
}

/**
 * ホーム ガレージスライダー（表示位置で自動再生開始）
 */
document.querySelectorAll('.s-home__garage-slider').forEach((el) => {
  const swiper = new Swiper(el, {
    loop: true,
    effect: 'fade',
    speed: 2000,
    autoplay: {
      delay: 3000,
      disableOnInteraction: false,
    },
    pagination: {
      el: el.querySelector('.swiper-pagination'),
      clickable: true,
    },
  });
  swiper.autoplay.stop();

  const observer = new IntersectionObserver(
    (entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          swiper.autoplay.start();
        } else {
          swiper.autoplay.stop();
        }
      });
    },
    { threshold: 0.3 },
  );
  observer.observe(el);
});

/**
 * タイプ診断 カードスライダー（表示位置で自動再生開始）
 */
document.querySelectorAll('.s-simulator__slider').forEach((el) => {
  const swiper = new Swiper(el, {
    loop: true,
    effect: 'fade',
    speed: 2000,
    autoplay: {
      delay: 3000,
      disableOnInteraction: false,
    },
    pagination: {
      el: el.querySelector('.swiper-pagination'),
      clickable: true,
    },
  });
  swiper.autoplay.stop();

  const observer = new IntersectionObserver(
    (entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          swiper.autoplay.start();
        } else {
          swiper.autoplay.stop();
        }
      });
    },
    { threshold: 0.3 },
  );
  observer.observe(el);
});

/**
 * カラーシミュレーター
 */
document.querySelectorAll('.s-simulator__color').forEach((section) => {
  const canvas = section.querySelector('.s-simulator__color-canvas');
  if (!canvas) return;

  section.querySelectorAll('.s-simulator__color-swatches').forEach((group) => {
    const target = group.dataset.target;
    const urls = JSON.parse(group.dataset.urls || '{}');

    group.querySelectorAll('.s-simulator__color-swatch').forEach((swatch) => {
      swatch.addEventListener('click', () => {
        group.querySelectorAll('.s-simulator__color-swatch').forEach((s) => s.classList.remove('is-active'));
        swatch.classList.add('is-active');

        const layer = canvas.querySelector(`[data-part="${target}"]`);
        if (!layer || !urls[swatch.dataset.color]) return;

        // 前回のクローンが残っていれば即削除
        canvas.querySelectorAll(`.is-clone[data-clone="${target}"]`).forEach((el) => el.remove());

        // 古い画像のクローンを上に重ねる
        const oldClone = layer.cloneNode(true);
        oldClone.removeAttribute('data-part');
        oldClone.dataset.clone = target;
        oldClone.classList.add('is-clone');
        layer.after(oldClone);

        // クローンの下で元画像のsrcを更新
        layer.src = urls[swatch.dataset.color];

        // 新画像の読み込み完了後、クローンをフェードアウト
        layer.addEventListener(
          'load',
          () => {
            requestAnimationFrame(() => {
              oldClone.classList.add('is-fading');
              setTimeout(() => oldClone.remove(), 300);
            });
          },
          { once: true },
        );
      });
    });
  });
});

/**
 * お問い合わせ 画像添付
 */
if (document.querySelector('.s-contact')) {
  const picInput = document.getElementById('pic');
  const formImage = document.querySelector('.mw-wp-form_image');

  if (formImage && picInput) {
    picInput.style.display = 'none';
  }

  document.querySelector('.mwform-file-delete')?.addEventListener('click', () => {
    if (picInput) picInput.style.display = '';
  });

  picInput?.addEventListener('change', function () {
    const file = this.files[0];
    if (file) {
      const picName = document.querySelector('.s-contact__picname');
      if (picName) picName.textContent = file.name;
      if (formImage) formImage.style.display = 'none';
    }
  });
}
